import { render } from "./MarkdownViewer.vue?vue&type=template&id=9e57cfee"
import script from "./MarkdownViewer.vue?vue&type=script&lang=js"
export * from "./MarkdownViewer.vue?vue&type=script&lang=js"

import "./MarkdownViewer.vue?vue&type=style&index=0&id=9e57cfee&lang=scss"

import exportComponent from "C:\\Users\\Callum\\Desktop\\k1890584_watkins_callum_code\\mo-books\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__